export const ageOptions = [
  {
    name: 'Umur 4 - 5 tahun',
    value: [4, 5],
  },
  {
    name: 'Umur 6 - 7 tahun',
    value: [6, 7],
  },
  {
    name: 'Umur 8 - 9 tahun',
    value: [8, 9],
  },
  {
    name: 'Umur 10 - 11 tahun',
    value: [10, 11],
  },
  {
    name: 'Umur 10 - 12 tahun',
    value: [10, 12],
  },
]

export type AgeOption = (typeof ageOptions)[number]
